import { SelectProps, Text } from '@mantine/core';
import { forwardRef } from 'react';

import { fonts } from '../../../fonts';
import { Select } from '../../selects/Select';
import { SelectOption } from '../../selects/SelectOption';

type FontFamilyPickerProps = {
  placeholder?: string;
  title?: string;
} & Omit<SelectProps, 'data'>;

export function FontFamilyPicker(props: FontFamilyPickerProps) {
  const { onChange, value, placeholder, title, ...rest } = props;

  return (
    <Select
      title={title}
      contentEditable
      placeholder={placeholder}
      renderOption={renderFontOption}
      value={value}
      onChange={onChange}
      data={fonts}
      {...rest}
    />
  );
}

type FontOptionProps = React.ComponentPropsWithoutRef<'div'> & {
  label: string;
  value: string;
  checked?: boolean;
};

const renderFontOption: SelectProps['renderOption'] = ({ option, checked }) => (
  <FontOption label={option.label} value={option.value} checked={checked} />
);

export const FontOption = forwardRef<HTMLDivElement, FontOptionProps>((props, ref) => {
  const { label, value, checked } = props;

  return (
    <SelectOption checked={checked}>
      <Text w="100%" ref={ref} ff={value} truncate>
        {label}
      </Text>
    </SelectOption>
  );
});

FontOption.displayName = 'FontOption';
